module.exports = __webpack_public_path__ + "static/media/uploadImg.4acb3716.svg";